export default __webpack_public_path__ + "static/media/full-layer-image-mobile.88a94db7.png";